module.exports = __webpack_public_path__ + "static/images/phone.3ISO2EX.svg";